import * as React from 'react'
import { SVGProps } from 'react'

const ETHUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='18' height='28' viewBox='0 0 18 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M8.99726 0L8.81152 0.638087V19.1523L8.99726 19.3397L17.4946 14.2597L8.99726 0Z' fill='#343434'></path>
    <path d='M8.99751 0L0.5 14.2597L8.99751 19.3397V10.3534V0Z' fill='#8C8C8C'></path>
    <path
      d='M8.99726 20.9667L8.89258 21.0958V27.6908L8.99726 27.9999L17.4998 15.8894L8.99726 20.9667Z'
      fill='#3C3C3B'></path>
    <path d='M8.99751 27.9999V20.9667L0.5 15.8894L8.99751 27.9999Z' fill='#8C8C8C'></path>
    <path d='M8.99707 19.3398L17.4944 14.2599L8.99707 10.3535V19.3398Z' fill='#141414'></path>
    <path d='M0.5 14.2599L8.99751 19.3398V10.3535L0.5 14.2599Z' fill='#393939'></path>
  </svg>
)

export default ETHUSD
